import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const Wraper = styled("div")``;

export const ProgressWraper = styled("div")`
  position: relative;
  width: 238px;
  height: 40px;
  margin-bottom: 10px;
  border-radius: 50px;
  overflow: hidden;
  border: 1px solid ${({ setColor }) => setColor};
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
`;

export const Progres = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ progress }) => progress}%;
  height: 100%;
  background-color: ${({ setColor }) => setColor};
  transition: width 20ms ease-in-out;
  color: #ffffff;
`;

export const PreloadText = styled("p")`
  margin-right: 10px;
  white-space: nowrap;
`;

export const LoaderWraper = styled("div")`
  display: flex;
  align-items: center;
`;

export const StyledLink = styled(Link)`
  color: #000;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-weight: 600;
`;

export const Data = styled("p")`
  font-weight: 700;
`;

export const Loader = styled("div")`
  border: 2px solid #c0c0c0;
  border-top: 2px solid #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
